import { IcPlus as IcPlus24, IcReconnection } from '@assets/icons/24x24';
import { HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import {
  useFlightPlansManagementContext,
  ViewType,
} from '@components/cockpit/panels/flightPlan/FlightPlansManagementContext';
import CustomChipList from '@components/common/inputs/CustomChipList';
import { Tooltip } from '@components/ui/tooltip';
import { useLazyGetActivationsQuery } from '@services/utm/activation.api';
import { FormattedMessage, useIntl } from 'react-intl';

export default function FlightPlansActions({ onCreate }: Readonly<{ onCreate: () => void }>) {
  const { formatMessage } = useIntl();

  const { criteria, view, setView, activationAndFlightPlans, canCreateFlightPlan, dispatch } =
    useFlightPlansManagementContext();
  const [triggerGetAll, { isFetching }] = useLazyGetActivationsQuery();
  const chipOptions = [
    {
      label: formatMessage({ id: 'components.flightPlans.list' }),
      value: 'list',
    },
    {
      label: formatMessage({ id: 'components.flightPlans.mixed' }),
      value: 'mixed',
    },
  ];

  const handleReload = () => {
    triggerGetAll(criteria)
      .unwrap()
      .then((activationAndFlightPlans) => dispatch({ type: 'SET_ALL', payload: activationAndFlightPlans }));
  };

  return (
    <>
      <Text color="neutral.500" userSelect="none">
        <FormattedMessage id="components.flightPlans.result" values={{ count: activationAndFlightPlans.length }} />
      </Text>
      <HStack marginLeft="auto" height="100%" flexShrink={0} gap={3} paddingLeft={2}>
        <HStack gap={1} flexShrink={0}>
          <Text color="neutral.200">
            <FormattedMessage id="components.flightPlans.view" />
          </Text>
          <CustomChipList
            availableOptions={chipOptions}
            selectedOptions={chipOptions.filter((option) => option.value === view)}
            distinctValues={['mixed', 'list']}
            onChange={(value) => setView(value[0] as ViewType)}
          />
        </HStack>
        <Tooltip content={formatMessage({ id: 'components.flightPlans.reload' })}>
          <IconButton
            aria-label="Reload list"
            onClick={handleReload}
            loading={isFetching}
            variant="cockpitHeader"
            boxSize="56px"
          >
            <Icon as={IcReconnection} boxSize="24px" />
          </IconButton>
        </Tooltip>
        {canCreateFlightPlan && (
          <IconButton aria-label="Add" variant="transparent" boxSize="56px" marginLeft="auto" onClick={onCreate}>
            <Icon as={IcPlus24} boxSize="24px" />
          </IconButton>
        )}
      </HStack>
    </>
  );
}
